import "./ContestClaimWinnings.scss"
import { gettext, interpolate } from "@multimediallc/web-utils"
import { useAppContext } from "../../../hooks/appContext"
import { Sizes, Weights } from "../../../interfaces/sizing"
import { normalizeResource } from "../../../routes/util"
import { Typography } from "../../common"

const i18n = {
    claimWinningsText: gettext("Claim Winnings"),
    claimWinningsDescription: (languageCode: string): string => {
        return interpolate(
            gettext(
                'To claim your winnings, fill out the <a class="link hrefColor" href="%(link)s">payment information form</a> for the Chaturbate affiliate program.',
            ),
            {
                link: normalizeResource(languageCode, "/affiliates/payoutinfo"),
            },
            true,
        )
    },
}

export function ContestClaimWinnings() {
    const languageCode = useAppContext().context.language_code

    return (
        <div className="ContestClaimWinnings">
            <Typography
                size={Sizes.md}
                weight={Weights.medium}
                component="h2"
                className="heading"
            >
                {i18n.claimWinningsText}
            </Typography>
            <Typography
                size={Sizes.xs}
                component="p"
                dangerouslySetInnerHTML={{
                    __html: i18n.claimWinningsDescription(languageCode),
                }}
            />
        </div>
    )
}
